import { UiSchema } from '@rjsf/utils'

import { FormProperties } from '../imup/types'
import { OpeningGroup } from '../models/activeDrawable'

export const uiSchema: UiSchema = {
    type: {
        'ui:title': 'Canales Type',
        'ui:placeholder': 'Select Canales Type',
    },
    length: {
        'ui:title': 'Length',
        'ui:placeholder': 'Canales Length',
    },
}

const onValidate = () => {}

const onSubmit = (settings, formData): OpeningGroup['settings'] => ({
    ...settings,
    ...formData,
})

const form: FormProperties = { uiSchema, onValidate, onSubmit }

export default form
